import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_PermissionProject } from './ModuleFE_PermissionProject.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { TS_Icons } from '@nu-art/ts-styles';
const Props_DropDown = {
    module: ModuleFE_PermissionProject,
    modules: [ModuleFE_PermissionProject],
    mapper: item => [item.name],
    placeholder: 'Choose a PermissionProject',
    renderer: item => _jsx(_Fragment, { children: item.name })
};
export const DropDown_PermissionProject = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_PermissionProject,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(TS_Icons.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.name] });
    },
    uiSelector: DropDown_PermissionProject.selectable,
});
export const MultiSelect_PermissionProject = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map